import loadable from '@loadable/component';

export const WydPageLoadable = loadable(() => import('./WydPage'), {
  resolveComponent: (module) => module.WydPage,
});
